<template>
  <div class="content_main">
    <div class="content_main_top">
      <a-select
        placeholder="所属流程"
        allowClear
        show-search
        :filter-option="filterOption"
        class="a_input_self margin_self"
        v-model="queryParam.procDefKey"
        @keyup.enter.native="$refs.table.refresh(true)"
      >
        <a-select-option :value="item.id" v-for="(item, index) in Approvallist" :key="index">
          {{ item.name }}
        </a-select-option>
      </a-select>
      <a-select
        class="a_input_self margin_self"
        allowClear
        placeholder="请选择公司"
        v-model="queryParam.companyId"
        @change="handlecompanyplan"
      >
        <a-select-option :value="item.value" v-for="(item, index) in companylist" :key="index">
          {{ item.title }}
        </a-select-option>
      </a-select>
      <a-tree-select
        class="a_input_self margin_self"
        allowClear
        :treeData="deptTree"
        placeholder="请选择部门"
        :disabled="!this.queryParam.companyId"
        v-model="queryParam.deptId"
      >
      </a-tree-select>
      <a-input
        placeholder="申请编号"
        allowClear
        class="a_input_self margin_self"
        v-model="queryParam.applyCode"
        @keyup.enter.native="$refs.table.refresh(true)"
      />
      <a-input
        placeholder="申请标题"
        allowClear
        class="a_input_self margin_self"
        v-model="queryParam.title"
        @keyup.enter.native="$refs.table.refresh(true)"
      />
      <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
      <a-button @click="resetQueryParam">重置</a-button>
      <a-button :disabled="selectedRowKeys.length === 0" type="danger" icon="delete" @click="delByIds(selectedRowKeys)"
        >删除</a-button
      >
    </div>
    <div class="content_main_center_scroll" id="content_main_center_scroll">
      <s-table
        size="default"
        ref="table"
        rowKey="auditId"
        :rowSelection="rowSelection"
        :columns="columns"
        :data="loadData"
        :scroll="{ y: scroll_y }"
         defaultSort="applyTime"
      >
        <span slot="serial" slot-scope="text, record, index">
          {{ index + 1 }}
        </span>
        <span slot="result" slot-scope="text" class="tag_class" :style="{ background: result_apply[text].color }">
          {{ text | resultFilter }}
        </span>
        <span slot="auditor" slot-scope="text">
          {{ text.split('-')[0] }}
        </span>
        <span slot="action" slot-scope="text, record">
          <a v-if="infoTaskdone" @click="handelAudit(record)">详情</a>
          <!-- <a-divider type="vertical" />
          <a v-if="historyTaskdone" @click="handFlow(record)">历史</a> -->
          <!-- <a-divider v-if="!record.delFlag" type="vertical" />
					<a v-if="!record.delFlag && deleteTaskdone" @click="delByIds([record.auditId])">删除</a> -->
        </span>
      </s-table>
      <leave-modal ref="leavemodal" @ok="handleOk" :audit="audit" />
      <purchase-modal ref="purchasemodal" @ok="handleOk" :audit="false" />
      <proc-flow-modal ref="modal" @ok="handleOk" />
      <!-- 报废 -->
      <scrap-modal ref="scrapmodal" @ok="handleOk" :audit="false" />
      <!-- 审批领用 -->
      <receive-modal ref="receiveModal" @ok="handleOk" :audit="audit" />
      <operation-modal ref="operationmodal" @ok="handleOk" :audit="false" />
      <service-modal ref="servicemodal" @ok="handleOk" :audit="false" />
      <reimbursement-modal ref="reimbursementmodal" @ok="handleOk" :audit="false" />
      <!-- 详情 -->
      <payMentModal ref="paymentmodal" @ok="handleOk" :audit="false" />
      <!-- 详情 -->
      <contractModal ref="contractmodal" @ok="handleOk" :audit="false" />
      <sealModal ref="sealmodal" :audit="false" />
      <currencyModal ref="currencymodal" :audit="false" />
      <returnModal ref="returnmodal" @ok="handleOk" :audit="false" />
      <car-modal ref="carmodal" @ok="handleOk" :audit="false" />
      <returncar-modal ref="returncarmodal" @ok="handleOk" :audit="false" />
      <salaryModal ref="salarymodal" @ok="handleOk" :audit="false" />
      <adjustmentModal ref="adjustmentmodal" @ok="handleOk" :audit="false" />
      <charge-modal ref="chargemodal" @ok="handleOk" :audit="false" />
      <other-modal ref="othermodal" @ok="handleOk" :audit="false" />
      <feedback-modal ref="feedbackmodal" @ok="handleOk" :audit="false" />
      <inventory-modal ref="inventorymodal" @ok="handleOk" :audit="false" />
      <newPaymentModel ref="newPaymentModel"></newPaymentModel>
      <salaryEditModal ref="salaryEditModal" :audit="false"></salaryEditModal>
      <quotation ref="quotation" :audit="false"></quotation>
      <contractReview ref="contractReview" :audit="false"></contractReview>
      <tender ref="tender" :audit="false"></tender>
	  	<contractDetail ref="contractDetail"  :audit="false"></contractDetail>
      <terminationModal ref="terminationModal"  :audit="false"></terminationModal>


    </div>
  </div>
</template>

<script>
import salaryEditModal from './modules/salaryEditModal.vue'
import { tree_all } from '@/api/purchase'
import { millsToTime } from '@/utils/util'
import { STable } from '@/components'
import { getTaskdone_cc, delTaskLogic, processInsState, modalMap } from '@/api/activiti'
import { audit_list } from '@/api/financial'
import LeaveModal from './modules/LeaveModal.vue'
import PurchaseModal from './modules/PurchaseModal.vue'
import ProcFlowModal from './modules/ProcFlowModal.vue'
import receiveModal from './modules/receiveModal.vue' //领用
import ScrapModal from './modules/ScrapModal.vue' //报废
import OperationModal from './modules/OperationModal.vue'
import ServiceModal from './modules/ServiceModal.vue'
import ReimbursementModal from './modules/ReimbursementModal.vue'
import payMentModal from '@/views/activiti/modules/payMentModal.vue'
import contractModal from '@/views/activiti/modules/contractModal.vue'
import sealModal from '@/views/activiti/modules/sealModal.vue'
import currencyModal from '@/views/activiti/modules/currencyModal.vue'
import returnModal from '@/views/activiti/modules/returnModal.vue'
import carModal from '@/views/activiti/modules/carModal.vue'
import returncarModal from '@/views/activiti/modules/returncarModal.vue'
import salaryModal from '@/views/activiti/modules/salaryModal.vue'
import adjustmentModal from '@/views/activiti/modules/adjustmentModal.vue'
import chargeModal from '@/views/activiti/modules/chargeModal.vue'
import otherModal from '@/views/activiti/modules/otherModal.vue'
import feedbackModal from '@/views/activiti/modules/feedbackModal.vue'
import InventoryModal from '@/views/activiti/modules/InventoryModal.vue'
import { checkPermission } from '@/utils/permissions'
import newPaymentModel from './modules/newPaymentModel.vue'
import quotation from './modules/quotation.vue'
import contractReview from '@/views/activiti/modules/contractReview.vue'
import tender from '@/views/activiti/modules/tender.vue'
import contractDetail from '@/views/projectCollection/contract/contractDetail.vue'
import terminationModal from '@/views/activiti/modules/terminationModal.vue'





const resultMap = {
  1: '处理中',
  2: '通过',
  3: '驳回',
  4: '撤销',
}
export default {
  name: 'Tasking',
  components: {
    contractDetail,
    tender,
    contractReview,
    quotation,
    salaryEditModal,
    STable,
    LeaveModal,
    ProcFlowModal,
    PurchaseModal,
    receiveModal,
    ScrapModal,
    OperationModal,
    ServiceModal,
    ReimbursementModal,
    payMentModal,
    contractModal,
    sealModal,
    currencyModal,
    returnModal,
    carModal,
    returncarModal,
    salaryModal,
    adjustmentModal,
    chargeModal,
    otherModal,
    feedbackModal,
    InventoryModal,
    newPaymentModel,
    terminationModal
  },
  data() {
    return {
      deptTree: [],
      companylist: [],
      Approvallist: [],
      visible: false,
      scroll_y: 150,
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 5,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 16,
        },
      },
      form: this.$form.createForm(this),
      mdl: {},
      permissions: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        delFlag: false,
        companyId: undefined,
        deptId: undefined,
      },
      // 表头
      columns: [
        {
          title: '序号',
          scopedSlots: {
            customRender: 'serial',
          },
          width: 60,
        },
        {
          title: '审批编号',
          dataIndex: 'applyCode',
          width: 260,
          ellipsis: true,
        },
        {
          title: '申请标题',
          dataIndex: 'title',
          ellipsis: true,
          width: 200,
        },
        {
          title: '所属流程',
          dataIndex: 'procName',
          ellipsis: true,
        },
        {
          title: '申请人',
          dataIndex: 'applyer',
          ellipsis: true,
        },
        {
          title: '申请时间',
          dataIndex: 'applyTime',
          sorter: true,
          ellipsis: true,
        },
        {
          title: '最后审批人',
          dataIndex: 'auditor',
          scopedSlots: {
            customRender: 'auditor',
          },
        },
        {
          title: '最后审批时间',
          dataIndex: 'endTime',
          ellipsis: true,
        },
        {
          title: '审批结果',
          dataIndex: 'result',
          scopedSlots: {
            customRender: 'result',
          },
        },
        {
          title: '操作',
          width: '150px',
          dataIndex: 'action',
          scopedSlots: {
            customRender: 'action',
          },
        },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        return getTaskdone_cc(Object.assign(parameter, this.queryParam))
      },
      audit: false,
      previewVisible: false,
      previewImage: '',
      selectedRowKeys: [],
      selectedRows: [],
      infoTaskdone: checkPermission('settings:taskdone:info'),
      historyTaskdone: checkPermission('settings:taskdone:history'),
      deleteTaskdone: checkPermission('settings:taskdone:delete'),
    }
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        getCheckboxProps: (record) => ({
          props: {
            disabled: record.delFlag, // Column configuration not to be checked
          },
        }),
      }
    },
  },
  filters: {
    resultFilter(status) {
      return resultMap[status]
    },
  },
  created() {
    audit_list().then((res) => {
      this.Approvallist = res.data
    })
    tree_all().then((res) => {
      if (res.code == 200) {
        this.companylist = res.data[0]
      }
    })
  },
  mounted() {
    this.$nextTick(() => {
      var max_h = $('#content_main_center_scroll').height()
      setTimeout(() => {
        this.scroll_y = max_h - $('.ant-table-header').height()-40
      }, 1000)
    })
  },
  methods: {
    resetQueryParam() {
      this.queryParam.procDefKey = ''
      this.queryParam.companyId = undefined
      this.queryParam.deptId = undefined
      this.queryParam.title = ''
      this.queryParam.applyCode = ''
      this.$refs.table.refresh(true)
    },
    handlecompanyplan(e) {
      console.log(this.queryParam, 'queryParam========================')
      this.deptTree = []
      this.queryParam.deptId = undefined
      this.$nextTick(() => {
        this.companylist.forEach((item) => {
          if (item.value == e) {
            this.deptTree = item.children
          }
        })
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    handleOk() {
      this.$refs.table.refresh(true)
      console.log('handleSaveOk')
    },
    handFlow(row) {
      var obj = {
        procInstId: row.procInstId,
        procDefKey: row.procDefKey,
      }
      this.$refs.modal.show(obj)
    },
    handelAudit(record) {
        Object.assign(record,{
        recordNumber: 1
      } )
       var fdStart =  record.procDefKey.indexOf("payment-")
       console.log(record.procDefKey, 'record.procDefKey============================')
       console.log(fdStart, 'fdStart========================')
				if(fdStart == 0) {
					this.$refs.newPaymentModel.show(record)
				} else {
          const modal = modalMap[record.procDefKey]
          if(record.procDefKey === 'project-terminate' ) {
           Object.assign(record, {
            businessKey : record.tableId
           }) 
          }
          this.$refs[modal].show(record)
        }
    },
    handleState(record) {
      const state = record.isSuspended ? 'active' : 'suspend'
      processInsState(record.procInstId, state).then((res) => {
        if (res.code === 200) {
          record.isSuspended = !record.isSuspended
        }
      })
    },
    delByIds(ids) {
      if (ids.length > 0) {
        delTaskLogic({
          ids: ids.join(','),
        }).then((res) => {
          if (res.code === 200) {
            this.$message.success(`删除成功`)
            this.handleOk()
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        this.$message.error('没有选择数据')
      }
      this.selectedRowKeys = []
    },
  },
  watch: {

			  // 'selectedRows': function (selectedRows) {
			  //   this.needTotalList = this.needTotalList.map(item => {
			  //     return {
			  //       ...item,
			  //       total: selectedRows.reduce( (sum, val) => {
			  //         return sum + val[item.dataIndex]
			  //       }, 0)
			  //     }
			  //   })
			  // }
			
  },
}
</script>
